EC.refreshCsrf = function () {

  'use strict';

  function init() {
    const forms = [ ...document.querySelectorAll('.js-custom-form') ];
    if (forms) {
      try {
        fetch(`/actions/users/session-info`, {
          headers: {
            Accept: 'application/json',
          },
        }).then(result => result.json())
          .then(result => {
            forms.forEach((form) => {
              const csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
              csrfInput.value = result.csrfTokenValue;
            });
          });
      } catch (error) {
        console.error('Failed to fetch CSRF token:', error);
      }
    }
  }

  return {
    init: init
  };

}();
